module.exports = __webpack_public_path__ + "static/media/as_text.a880e486.png";